module.exports = __webpack_public_path__ + "static/5223-ecbc71841e69335c27bec9bdb9305059.png";